import { Record } from 'immutable';
import { Party } from './party';
import { RatePlanCode } from './rate-plan-code';

const EventRecord = Record({
  eventId: null,
  version: null,
  createdDate: null,
  modifiedDate: null,
  eventAgency: new Party(),
  eventClient: new Party(),
  eventProperty: new Party(),
  eventVendors: [],
  inactive: null,
  autoGenerated: false,
  autoPayment: null,
  canBeDeleted: false,
  canBeUnmatched: false,
  canManageReservations: false,
  currency: null,
  ratePlanCodes: [],
  shoulderDatesCommission: false,
  city: null,
  state: null,
  countryCode: null,
  eventMatchId: null,
  evTmpGuid: null,
  hasOoivExceptions: null
});

export class OnyxEvent extends EventRecord {
  eventId: number;
  version: number;
  createdDate: Date;
  modifiedDate: Date;
  eventAgency: Party;
  eventClient: Party;
  eventProperty: Party;
  eventVendors: Party[];
  inactive: string;
  autoGenerated: boolean;
  autoPayment: boolean;
  canBeDeleted: boolean;
  canBeUnmatched: boolean;
  canManageReservations: boolean;
  eventReferenceNumber: string;
  currency: string;
  ratePlanCodes: RatePlanCode[];
  shoulderDatesCommission: boolean;
  city: string;
  state: string;
  countryCode: string;
  eventMatchId: number;
  evTmpGuid: string;
  hasOoivExceptions: boolean;

  public isAgencyControlled(): boolean {
    return !this.eventProperty.subscriber;
  }

  public isPropertyControlled(): boolean {
    return this.eventProperty.subscriber;
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event.ts